var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 4,
    viewBox: "0 0 28 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CACCCF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 2,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.f023297de34d07cf345551e58bfff8e5.svg";
export { ForwardRef as ReactComponent };